import { call } from './apiHelpers';

export const financeService = {
  getAll: (filters) => call('get', 'finance/', null, filters),
  getSummary: () => call('get', 'finance/summary/'),
  updateAllocation: (voterId, payload) =>
    call('patch', `finance/voters/${voterId}/`, payload),
};
